import { WidgetTourConfig } from '../models'
import { isWidgetTourSeen } from '../shared/widgetTourStorage'

export const isWidgetTourEligible = (tour: WidgetTourConfig, includeSeen = false): boolean => {
  return (
    tour.enabled === true && tour.steps.length > 0 && (includeSeen || !isWidgetTourSeen(tour.id))
  )
}
